// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { CtsGantryStepStatusEType } from '../enum/cts-gantry-step-status-type';

@Injectable({ providedIn: 'root' })
export class CtsGantryInitStepStatusService {
  private readonly SUCCESS = 'Success';
  private readonly ERROR = 'Error';
  private readonly NULL = null;

  private readonly statusMap = new Map<string | null, CtsGantryStepStatusEType>(
    [
      [this.SUCCESS, CtsGantryStepStatusEType.EXECUTED],
      [this.ERROR, CtsGantryStepStatusEType.FAILED],
      [this.NULL, CtsGantryStepStatusEType.NOT_EXECUTED],
    ],
  );

  public translate(
    eventType: string | null,
    isSuccessful: boolean,
  ): CtsGantryStepStatusEType {
    const result =
      this.statusMap.get(eventType) ?? CtsGantryStepStatusEType.NOT_EXECUTED;

    return result === CtsGantryStepStatusEType.EXECUTED && isSuccessful
      ? CtsGantryStepStatusEType.SUCCESSFUL
      : result;
  }

  public mapToIcon(eventType: string | null): string {
    let result = '';
    if (this.SUCCESS === eventType) {
      result = 'success';
    } else if (this.ERROR === eventType) {
      result = 'error';
    }

    return result;
  }
}
